import { useRecordContext } from "react-admin";
import RejectModal from "components/Alumni/AlumniProfiles/RejectModal";
import { alumniRequests } from "api/alumniApi";

const RejectAlumniProfile = () => {
  const record = useRecordContext();

  return (
    <RejectModal
      request={alumniRequests.rejectAlumniProfile(record?.id)}
      titleContent="Отказ на Алумни профил"
      successMessage="Успешна редакция на статус"
    />
  );
};

export default RejectAlumniProfile;
